<template>
    <div id="app" :class="{ container: isShowContainer }">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>
<script>
export default {
    computed: {
        isShowContainer() {
            return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(
                navigator.userAgent
            );
        },
    },
    async mounted() {
        if (
            !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
        ) {
            require("@/assets/css/PC/PC.less");
        } else {
            require("@/assets/css/Mobile/mobile.less");
        }
    },
};
</script>

<style lang="less">
@import url(./assets/css/public.less);
</style>
